import ReactGA from "react-ga4";

export const track = (eventName: string, params?: Record<string, any>) => {
  ReactGA.event(eventName, params);
};
